import React from 'react';
import { useSelector } from 'react-redux';
import { useRequestData, usePrefs, useFlags, useLabels } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import { getUrlParams } from '../utilities/url-params'; // TODO(Post-flag cleanup - Item 31): Remove legacy parser import when deleting url-params.js
import { InvData, InvDataRefactored } from '../data';
import {
	getWISRequestBody,
	requestFacets,
	requestInventory,
	requestInventoryAndFacets,
	fetchWISVehicle
} from '../utilities/WISutils';
import { spellcheckProxyFetch } from '../utilities/freeFormSearchUtils';

/* eslint-disable react/no-danger */
const Widget = () => {
	const flags = useFlags();
	const labels = useLabels();

	const {
		moreRequestData,
		moreRequestData: { useWIS, isComposer, useInvDataRefactor }
	} = useSelector((state) => state);
	const requestData = {
		...useRequestData(),
		...moreRequestData
	};

	const prefs = usePrefs();

	const requestWISFacets = (
		invParams,
		start,
		sortBy,
		eventType,
		eventData
	) => {
		const facetRequestBody = getWISRequestBody({
			requestData,
			prefs,
			invParams,
			start,
			flags
		});
		return requestFacets(
			invParams,
			sortBy,
			facetRequestBody,
			eventType,
			eventData
		);
	};

	const requestWISInventory = (invParams, sortBy, start) => {
		// Add additionalInventoryFields needed by web integrations from the dataLayer
		if (isBrowser && window.DDC?.dataLayer?.additionalInventoryFields) {
			prefs['required.tracking.attributes'] =
				window.DDC.dataLayer.additionalInventoryFields.join(',');
		}

		const inventoryRequestBody = getWISRequestBody({
			requestData,
			prefs,
			invParams,
			sortBy,
			start,
			flags
		});
		return requestInventory(invParams, inventoryRequestBody);
	};

	const requestWISVehicle = () => {
		if (!useWIS && requestData.featuredPromotion) {
			const vehicleRequestBody = getWISRequestBody({
				requestData,
				prefs,
				flags
			});

			return fetchWISVehicle(vehicleRequestBody);
		}
		return null;
	};

	const requestSpellcheck = (searchTerm) => {
		const { siteId } = requestData;
		const { 'listing.config.id': listingType } = prefs;
		return spellcheckProxyFetch(siteId, listingType, searchTerm, flags);
	};

	const requestWISInventoryAndFacets = (
		invParams,
		start,
		sortBy,
		eventType,
		eventData
	) => {
		// Add additionalInventoryFields needed by web integrations from the dataLayer
		if (isBrowser && window.DDC?.dataLayer?.additionalInventoryFields) {
			prefs['required.tracking.attributes'] =
				window.DDC.dataLayer.additionalInventoryFields.join(',');
		}

		const unifiedRequestBody = getWISRequestBody({
			requestData,
			prefs,
			invParams,
			start,
			sortBy,
			flags
		});
		return requestInventoryAndFacets(
			invParams,
			unifiedRequestBody,
			eventType,
			eventData
		);
	};

	if (isBrowser && !window.DDC?.InvData?.srpReady) {
		if (useInvDataRefactor) {
			// Use refactored WIS-only InvData
			window.DDC.InvData = new InvDataRefactored(
				requestSpellcheck,
				requestWISVehicle,
				requestWISInventoryAndFacets,
				prefs,
				labels,
				requestData.parameterMap || {}
			);
		} else {
			// Legacy InvData with GVM toggle
			window.DDC.InvData = new InvData(
				flags,
				requestWISFacets,
				requestWISInventory,
				requestSpellcheck,
				requestWISVehicle,
				useWIS,
				prefs,
				labels
			);
		}

		window.onpopstate = (e) => {
			if (e.state) {
				window.DDC.InvData.replaceSelections(
					e.state.urlParams,
					e.state.sortBy ? e.state.sortBy : '',
					e.state.start ? e.state.start : 0,
					false /* updateBrowserHistory */
				);
			} else {
				window.DDC.InvData.replaceSelections(
					getUrlParams(window.location.href), // TODO(Post-flag cleanup - Item 31): Drop usage; rely on stored state or server parameterMap.
					'',
					0,
					false
				);
			}
		};
	}

	if (!isComposer || !flags['srp-toggle-databus-editor']) {
		return null;
	}

	return (
		<>
			<p className="box box-border p-6 bg-primary text-center mt-4">
				<div data-display-sets="TITLE,IMAGE_ALT,IMAGE_TITLE,LISTING,CALLOUT" />
				<div className="composer-editor-only">
					<p
						dangerouslySetInnerHTML={{
							__html: labels.get(
								'INVENTORY_DATA_BUS_CONFIGURATION_VERBIAGE'
							)
						}}
					/>
				</div>
			</p>
		</>
	);
};

export default Widget;
